import { useRef, useMemo } from 'react';
import { useInformed } from './useInformed.js';

// const debug = Debug('informed:useInformedApi' + '\t');

/* ----------------------- useFieldState ----------------------- */

var useInformedApi = function useInformedApi() {
  // Grab informed
  var informed = useInformed();
  var informedRef = useRef();
  informedRef.current = informed;
  var informedApi = useMemo(function () {
    return {
      getFormApi: function getFormApi(name) {
        var _informedRef$current$;

        return (_informedRef$current$ = informedRef.current.getController(name)) === null || _informedRef$current$ === void 0 ? void 0 : _informedRef$current$.getFormApi();
      }
    };
  }, []);
  return informedApi;
};

export { useInformedApi };
